import { render } from "./ImportView.vue?vue&type=template&id=53be1421&scoped=true&ts=true"
import script from "./ImportView.vue?vue&type=script&lang=ts"
export * from "./ImportView.vue?vue&type=script&lang=ts"

import "./ImportView.vue?vue&type=style&index=0&id=53be1421&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53be1421"]])

export default __exports__